module.exports = __webpack_public_path__ + "img/kr-bg-top-left-new.89d8bca.png";